import { useLongPress } from 'ahooks';
import { Image as ImagePC, Space } from 'antd';
import { Ellipsis, Image as ImageMobile, ImageViewer, MultiImageViewerRef, Toast } from 'antd-mobile';
import { useThrottledHandler } from 'App';
import img from 'app/img';
import React, { useEffect, useRef, useState } from 'react';
import {
  AiOutlineArrowLeft,
  AiOutlineDownload,
  AiOutlineLeft,
  AiOutlineRight,
  AiOutlineRotateLeft,
  AiOutlineRotateRight,
  AiOutlineSwap,
  AiOutlineUndo,
  AiOutlineZoomIn,
  AiOutlineZoomOut,
} from 'react-icons/ai';
import { useLocation } from 'react-router-dom';
import { bizBaseUrl } from 'services/request';
import { useImmer } from 'use-immer';
import downloadUtil from 'utils/downloadUtil';
import { scrollTop } from 'utils/screenUtil';
import myStyles from './index.module.scss';

const ReaderPicture = () => {
  const state = useLocation().state;
  const chapterList = state?.chapterList || [];
  const postTitle: string = state?.postTitle;
  const imageInex = state?.imageInex;
  const images = chapterList?.map((item) =>
    // item.resourceRealityUrl?.replaceAll("\\", "/").replaceAll("D:/_Resource/",  bzBaseUrl + "/images/")
    item?.optImgUrl ? item.optImgUrl : ''
  );
  const [tempImages, updateTempImages] = useImmer(
    [images[0], images[1], images[2]].concat(new Array(images.length - 3).fill(''))
  );

  const imageViewerRef = useRef<MultiImageViewerRef>(null);
  const [currentIndex, setCurrentIndex] = useState(imageInex || 0);
  const [imageViewerVisible, setImageViewerVisible] = useState(false);

  const [darkMode, setDarkMode] = useState(true); // 黑暗模式/白天模式
  const [reelMode, setReelMode] = useState(true); // 卷轴模式/鉴赏模式
  const [showOptionPanel, toggleShowOptionShowPanel] = useState(true); // 是否显示操作面板

  // 下一页
  const goToNextPage = () => {
    if (currentIndex < images.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
      imageViewerRef.current?.swipeTo(currentIndex + 1);
    }
  };
  // 上一页
  const goToPreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
      imageViewerRef.current?.swipeTo(currentIndex - 1);
    }
  };

  let scrollTopLength = 0;
  let topValue = 0;
  // 滑动监听
  const getScollTop = () => {
    let scrollTop = 0;
    if (document?.documentElement && document?.documentElement?.scrollTop) {
      scrollTop = document?.documentElement.scrollTop;
    } else if (document?.body) {
      scrollTop = document?.body.scrollTop;
    }
    return scrollTop;
  };

  const bindHandleScroll = () => {
    if (!reelMode) {
      return;
    }
    scrollTopLength = getScollTop();
    if (scrollTopLength <= topValue) {
      // console.log("上划", showOptionPanel);
      toggleShowOptionShowPanel(true);
    } else {
      // console.log("下划", showOptionPanel);
      // setTimeout(() => {
      toggleShowOptionShowPanel(false);
      // }, 800);
    }
    setTimeout(function () {
      topValue = scrollTopLength;
    }, 100);
  };

  // 绑定滚动监听(不知道为什么会闪图。。)
  useEffect(() => {
    scrollTop();
    window.addEventListener('scroll', bindHandleScroll);
    return () => {
      window.removeEventListener('scroll', bindHandleScroll);
    };
  }, []);

  const tipPanelRef = useRef<HTMLDivElement>(null);

  const clickCount = useRef(0); // 用于点击监控的计数
  // // 点击监听 有些问题，滑动时也会触发
  // useLongPress(
  //   () => {
  //     // 长按开始
  //     // console.log("long press");
  //   },
  //   tipPanelRef,
  //   {
  //     // delay: 200,
  //     // moveThreshold: {},
  //     onClick: () => {
  //       clickCount.current += 1;
  //       setTimeout(() => {
  //         if (clickCount.current === 1) {
  //           // 单击
  //           toggleShowOptionShowPanel(!showOptionPanel);
  //           console.log('single click: ', clickCount);
  //         } else if (clickCount.current === 2) {
  //           // 双击
  //           console.log('setTimeout onDoubleClick: ', clickCount);
  //         }
  //         clickCount.current = 0;
  //       }, 500);
  //     },
  //     onLongPressEnd: () => {
  //       // 长按结束
  //       console.log('long press end');
  //     },
  //   }
  // );

  // 页面内容
  return (
    <div
    // className=" bg-slate-900"
    // style={{ height: window.innerHeight }}
    >
      {/* 标题 */}
      {true && showOptionPanel && reelMode && (
        <>
          <div className=" fixed top-0 w-full z-10">
            <div className={[' justify-center items-center p-3 bg-black bg-opacity-60 backdrop-blur-sm'].join(' ')}>
              <Ellipsis
                rows={1}
                // direction="middle"
                content={postTitle}
                className=" text-sm text-white font-bold mx-8 text-center"
              />
              <AiOutlineArrowLeft
                size={24}
                color="white"
                className=" absolute top-2.5 left-3"
                onClick={() => {
                  window.history.go(-1);
                }}
              />
            </div>
          </div>
        </>
      )}

      {/* 卷轴模式 */}
      {true && (
        <div
          className={[
            !reelMode && ' hidden',
            // ' bg-gradient-to-br from-slate-100/10 to-slate-500/30',
            '  bg-black ',
          ].join(' ')}
        >
          {/* 图片 */}
          <div className=" h-12 w-full text-white flex justify-center items-center">卷轴模式</div>
          {true && (
            <div
              className=" flex flex-col "
              ref={tipPanelRef}
            >
              {images?.map((image, index) => (
                <div key={image + index}>
                  <ImageMobile
                    crossOrigin="anonymous"
                    src={image}
                    alt={`Page ${currentIndex + 1}`}
                    // preview={false}
                    lazy
                    height={'100%'}
                    style={{
                      minHeight: window.innerWidth / 2,
                      height: '100%',
                      width: '100%',
                      objectFit: 'contain',
                    }}
                    placeholder={
                      <img
                        src={img.loadingImg}
                        style={{
                          minHeight: window.innerWidth / 2,
                          height: '100%',
                          width: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    }
                    fallback={
                      <img
                        src={img.loadingImg}
                        style={{
                          minHeight: window.innerWidth / 2,
                          height: '100%',
                          width: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    }
                  />
                  <div className=" h-1.5 -mt-0 overflow-hidden text-[5px] font-bold text-slate-500/80 text-center">
                    {index + 1}
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className=" h-20 w-full text-white flex justify-center items-center">———— 本 小 节 已 结 束 ————</div>
          {/* 操作 */}
          {showOptionPanel && (
            <>
              <div className=" fixed bottom-2 flex justify-around items-center w-full gap-2 p-2">
                <button
                  style={{
                    padding: '10px 10px',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    zIndex: 1000,
                  }}
                  className=" backdrop-blur-sm"
                  onClick={() => {
                    setReelMode(!reelMode);
                    toggleShowOptionShowPanel(true);
                  }}
                >
                  鉴赏模式
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* 鉴赏模式 */}
      {true && (
        <div
          className={[reelMode && ' hidden', ' '].join(' ')}
          style={{
            background: darkMode ? '#000' : '#fff',
            width: window.innerWidth,
            height: window.innerHeight,
          }}
        >
          {/* 图片 */}
          <ImageViewer.Multi
            classNames={{ mask: 'myStyles.customStyles', body: 'myStyles.customStyles' }}
            ref={imageViewerRef}
            maxZoom={2}
            // 笨方法实现懒加载5张。。。
            // images={images.map((image, index) =>
            //   ![currentIndex, currentIndex - 1, currentIndex - 2, currentIndex + 1, currentIndex + 2].includes(index)
            //     ? ''
            //     : image
            // )}
            // 笨方法实现懒加载3张。。。
            // images={images.map((image, index) => (index < currentIndex - 2 || index > currentIndex + 2 ? '' : image))}
            images={tempImages}
            visible={true}
            defaultIndex={currentIndex}
            onClose={() => {
              toggleShowOptionShowPanel(true);
            }}
            onIndexChange={(index) => {
              setCurrentIndex(index);
              updateTempImages((draft) => {
                draft.forEach((_, index, arr) => {
                  if (index < currentIndex - 1 || index > currentIndex + 1) arr[index] = '';
                  else arr[index] = images[index];
                });
              });
            }}
            renderFooter={(image: string, index: number) => {
              return (
                <div>
                  <div className=" fixed bottom-0 flex justify-around items-center w-full gap-2 p-2">
                    <button
                      onClick={goToPreviousPage}
                      style={{
                        padding: '10px 10px',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        zIndex: 1000,
                      }}
                      disabled={currentIndex === 0}
                    >
                      上一页
                    </button>
                    <button
                      style={{
                        padding: '10px 10px',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        zIndex: 1000,
                      }}
                      onClick={() => {
                        setReelMode(!reelMode);
                        toggleShowOptionShowPanel(true);
                      }}
                    >
                      卷轴模式
                    </button>
                    <button
                      className=" grow flex justify-center items-center"
                      style={{
                        padding: '8px 10px',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        zIndex: 1000,
                      }}
                    >
                      {/* {currentIndex + 1 + ' / ' + chapterList.length} */}
                      <AiOutlineDownload
                        size={24}
                        onClick={() => {
                          const imageUrl = images[currentIndex];
                          const imageSuffix = imageUrl.slice(imageUrl.lastIndexOf('.'));
                          const imageName =
                            '【uutt.me】' +
                            postTitle.substring(0, Math.min(10, postTitle.length)) +
                            '-' +
                            currentIndex +
                            imageSuffix;
                          downloadUtil.downloadImageStrong({ imageUrl, imageName });
                        }}
                      />
                    </button>
                    <button
                      style={{
                        padding: '10px 10px',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        zIndex: 1000,
                      }}
                      onClick={() => {
                        setDarkMode(!darkMode);
                      }}
                    >
                      {!darkMode ? '黑夜模式' : '白天模式'}
                    </button>
                    <button
                      onClick={() => {
                        goToNextPage();
                      }}
                      style={{
                        padding: '10px 10px',
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        zIndex: 1000,
                      }}
                      disabled={currentIndex >= chapterList.length - 1}
                    >
                      下一页
                    </button>
                  </div>
                  <div className=" fixed top-0 flex justify-around items-center w-full gap-2 p-2">
                    <AiOutlineArrowLeft
                      size={24}
                      color="white"
                      className=" absolute top-2.5 left-3"
                      onClick={() => {
                        window.history.go(-1);
                      }}
                    />
                  </div>
                </div>
              );
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ReaderPicture;
